import React from 'react';
import { Button } from '@dotcom/crown-ui';
import { CancelButtonProps } from '../quantity-change-dialog-types';

export const CancelButton = ({ click, label }: CancelButtonProps): React.ReactElement => {
  return (
    <Button onClick={click} variant="secondary" testId="cancel-button">
      {label}
    </Button>
  );
};
